import { useEffect, useState } from "react";
import { Navigation } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NAV_APPS, getPreferredNav, openNav } from "@/lib/nav";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const NavigateButton = ({ address, testid = "navigate-button" }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [preferred, setPreferred] = useState("");

  useEffect(() => setPreferred(getPreferredNav()), []);

  if (!address) return null;

  const choose = (id) => {
    openNav(id, address);
    setPreferred(id);
    setOpen(false);
  };

  const preferredLabel = NAV_APPS.find((a) => a.id === preferred)?.label;

  return (
    <>
      <div className="flex gap-2">
        <Button
          data-testid={testid}
          onClick={() => (preferred ? choose(preferred) : setOpen(true))}
          className="h-11 flex-1 bg-blue-600 text-white transition-colors duration-200 hover:bg-blue-700"
        >
          <Navigation className="mr-2 h-4 w-4" />
          {preferredLabel ? t("navigate.navigateWith", { app: preferredLabel }) : t("navigate.navigate")}
        </Button>
        <Button
          variant="outline"
          data-testid={`${testid}-choose`}
          onClick={() => setOpen(true)}
          className="h-11 bg-white transition-colors duration-200 hover:bg-slate-100"
        >
          {t("navigate.changeApp")}
        </Button>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="navigate-dialog" className="bg-white sm:max-w-xs">
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold">{t("navigate.chooseApp")}</DialogTitle>
          </DialogHeader>
          <div className="space-y-2">
            {NAV_APPS.map((a) => (
              <Button
                key={a.id}
                data-testid={`nav-app-${a.id}`}
                onClick={() => choose(a.id)}
                variant={preferred === a.id ? "default" : "outline"}
                className={`h-12 w-full justify-start text-base transition-colors duration-200 ${
                  preferred === a.id
                    ? "bg-blue-600 text-white hover:bg-blue-700"
                    : "bg-white hover:bg-slate-100"
                }`}
              >
                <Navigation className="mr-2 h-4 w-4" /> {a.label}
              </Button>
            ))}
          </div>
          <p className="text-xs text-slate-500">{t("navigate.savedDefault")}</p>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default NavigateButton;
